export default [
  { key: "Admin" },
  { key: "GroupCode" },
  { key: "Options" },
  { key: "Question" },
  { key: "Roles" },
  { key: "Setting" },
  { key: "Subject" },
  { key: "Exams" },
  { key: "Topic" },
  { key: "User" },

  { key: "Authenticate" },
  { key: "Dashboard" },
];
